



















import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as imageLinks from "@/config/image-links";


/**
 * Character cell component.
 */
@Component
export default class CharacterSpecCell extends Vue {
	// Injections
	imageLinks = imageLinks;
	classes = classes;

	@Prop({required: true})
	character!: {
		mainSpecNum: number;
		class: string;
	};

	@Prop({type: Boolean, default: false})
	simple!: boolean;
}
